

const fixColors: {[key: string]: string} = {
    "Verkaufsdaten": "#FF0000"
}

export const stringToColour = function(str: string) {

    if (str === "" || !str) {
        return "#000000";
    }

    if (fixColors[str])
        return fixColors[str];


    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let colour = '#';
    for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xFF;
        colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
}

export const MarketColors = {
    "0001": "#f27979",
    "0003": "#661b00",
    "0005": "#f2c6b6",
    "0006": "#ff6600",
    "0007": "#ffb380",
    "0008": "#664733",
    "0009": "#8c4b00",
    "0010": "#bf8000",
    "0011": "#665200",
    "0012": "#bfbc8f",
    "0013": "#303300",
    "0014": "#c2cc33",
    "0015": "#628040",
    "0016": "#118000",
    "0017": "#00e61f",
    "0019": "#b6f2c6",
    "0020": "#00401a",
    "0021": "#39e695",
    "0022": "#435952",
    "0023": "#20806c",
    "0024": "#00f2e2",
    "0025": "#006680",
    "0026": "#36b8d9",
    "0027": "#2d74b3",
    "0028": "#102940",
    "0031": "#b6d6f2",
    "0035": "#203980",
    "0036": "#737899",
    "0037": "#0d0d33",
    "0038": "#7979f2",
    "0041": "#6100f2",
    "0042": "#360066",
    "0048": "#da79f2",
    "0049": "#ee00ff",
    "0059": "#6f3973",
    "0061": "#e6acda",
    "0065": "#f200a2",
    "0074": "#40002b",
    "0077": "#d90057",
    "0078": "#8c234d",
    "0088": "#f279aa",
    "0089": "#997382",
    "9901": "#8800FF"
}
